import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import Logger from '../../Logger';

const logger = new Logger('TabIcon');

const styles = (theme) => ({
	tabIcon : {
		marginRight			: theme.spacing(1)
	}
});

const tabIcons = {
	'audio' : [`${window.app_base_path}/svg/settings/audio.svg`,`${window.app_base_path}/svg/settings/audio_selected.svg`],
	'video' : [`${window.app_base_path}/svg/settings/camera.svg`,`${window.app_base_path}/svg/settings/camera_selected.svg`],
	'virtualBg' : [`${window.app_base_path}/svg/settings/virtual_bg.svg`,`${window.app_base_path}/svg/settings/virtual_bg_selected.svg`],
	'appearance' : [`${window.app_base_path}/svg/settings/appearance.svg`,`${window.app_base_path}/svg/settings/appearance_selected.svg`],
}

const TabIcon = ({
	classes,
	tab = 'audio',
	selected = 0
}) => {

	//logger.debug(`tab: ${tab} selected: ${selected} ${JSON.stringify(tabIcons[tab])}`)

	const _imgUrl = tabIcons[tab][selected];

	return (<img style={{marginBottom: '0px'}} className={classes.tabIcon} src={_imgUrl} />);
};

TabIcon.propTypes =
{
	classes                    : PropTypes.object.isRequired
};

export default withStyles(styles)(TabIcon);